/*
 * @Description:
 * @Author: 山淑兰
 * @Date: 2020-01-06 14:17:08
 * @LastEditTime: 2020-05-12 14:27:24
 * @LastEditors: 山淑兰
 */
import Meeting from "@/api/index.ts";
import _ from "lodash";

export class current {
  /**
   * @title 深拷贝
   * @param value 需要clone的数据
   */
  cloneDeep(value: any) {
    let _cloneJson = _.cloneDeep(value);
    return _cloneJson;
  }
  /**
   * @title 通用时间戳转日期
   * @param {number} dates
   */
  changeTimeStam(dates: any) {
    let date, year, month, day, Hour, minute, second;
    date = new Date(dates);
    year = date.getFullYear();
    month = date.getMonth() + 1;
    day = date.getDate();
    Hour = date.getHours();
    minute = date.getMinutes();
    Hour = Hour < 10 ? "0" + Hour : Hour;
    minute = minute < 10 ? "0" + minute : minute;
    second = date.getSeconds();
    return {
      year,
      month,
      day,
      Hour,
      minute,
      second,
    };
  }
  /**
   * @title 后台时间数据转日期
   * @param {any} dates
   */
  changeFormDate(dates: any) {
    let _date = dates.split("(");
    let _dates = Number(_date[1].split(")")[0]);
    return this.changeTimeStam(_dates);
  }
  /**
   *  判断是否是移动端
   */
  is_Mobile() {
    let ua = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
    );
    if (ua) {
      return true;
    } else {
      return false;
    }
  }
  /**
   *  判断是否为微信访问
   */
  isWeiXin() {
    //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    var ua: any = window.navigator.userAgent.toLowerCase();
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    } else {
      return false;
    }
  }
  /**
   * @description:二级数据中字符串类型的数组转为数组类型
   */
  subData(forms: any[]) {
    for (let j = 0; j < forms.length; j++) {
      let { formtype, formval, formjsonval } = forms[j];
      console.log(j, formval);
      if (formtype === 2 || formtype === 4 || formtype === 8 || formtype === 3) {
        let _formjsonval;
        if (typeof formjsonval == "string") {
          _formjsonval = JSON.parse(formjsonval);
        } else {
          _formjsonval = formjsonval;
        }
        if (formtype === 3) {
          if (!formval) {
            forms[j].formval = [];
          }
        }
        forms[j].formjsonval = _formjsonval;

        if (formtype === 2) {
          forms[j].formval = formjsonval[0].value;
        }
      }
      console.log(j, "-", formval);
    }
    console.log("forms", forms);
    return forms;
  }
}
/**
 * @title 会议基本信息接口
 * @Date 2019-12-27
 */
import { InitMeetingInfo } from "@/api/modules/meeting/index.dto";
export const IMeetingInfo = {
  async InitMeetingInfo(params: InitMeetingInfo) {
    let isMobile = new current().is_Mobile();
	//console.log(window.location.href)
	let path = window.location.href
    if (isMobile && path.indexOf('/liveInfo') != -1 && path.indexOf('/liveinfo') != -1) {
      let _params = window.location.href.split("?")[1];
      window.location.href = `https://mp.weiqihd.com/mpweb/#/signup/meetingsignup?${_params}`;
    }
    let res = await Meeting.Meeting.InitMeetingInfo(params);

    document.title = res.MeetingTitle;
    return res;
  },
};
/**
 * @title 会议基本信息接口
 * @Date 2019-12-27
 */
import { IGetSignMeetingUserByMu } from "@/api/modules/signup/index.dto";
export const IUserByMu = {
  async GetSignMeetingUserByMu(params: IGetSignMeetingUserByMu) {
    let res = await Meeting.SignUp.GetSignMeetingUserByMu(params);

    return res;
  },
};
